export const getRelatedContentArray = (content, arr, n) => {
  let shuffled
  if (content === null) {
    shuffled = arr?.sort(() => 0.5 - Math.random())
  } else {
    const filteredArray = arr?.filter(item => item.documentId !== content.documentId)
    shuffled = filteredArray?.sort(() => 0.5 - Math.random())
  }
  return shuffled?.slice(0, n)
}
